import { faBookOpen, faCalendarDays, faCodePullRequest, faComments, faInfoSquare, faQuestionSquare, faUserGroup } from "@fortawesome/pro-duotone-svg-icons";
import { faCheck, faCircle, faTimesCircle } from "@fortawesome/pro-regular-svg-icons";
import { faCalendar, faCalendarCheck, faCalendarPlus, faCalendarTimes, faStar } from "@fortawesome/pro-solid-svg-icons";

export const getDuotoneIconByIconClass = (icon: string) => {
  switch (icon) {
    case "fas fa-calendar":
      return faCalendarDays;
    case "far fa-user":
      return faCodePullRequest;
    case "fas fa-newspaper":
      return faBookOpen;
    case "fas fa-info-circle":
      return faQuestionSquare;
    case "fas fa-users":
      return faUserGroup;
    case "fas fa-comments":
      return faComments;
    default:
      return faInfoSquare;
  }
}

export const getIconsByIconClass = (icon: string) => {
  switch (icon) {
    case "fas fa-calendar":
      return faCalendar;
    case "far fa-check-circle":
      return faCheck;
    case "fas fa-calendar-times":
      return faCalendarTimes;
    case "fas fa-calendar-check":
      return faCalendarCheck;
    case "fas fa-calendar-plus":
      return faCalendarPlus;
    case "far fa-circle":
      return faCircle;
    case "far fa-times-circle":
      return faTimesCircle;
    case "fa fa-star":
      return faStar;
  }
}